import { ApiClient } from "../base";
import { removeUndefinedKeys } from "@/utils/collect";
import { getAPIToken } from "@/utils/request";
export class CloudAgentExecutionClient extends ApiClient {
    getExecutionMetadata(executionId, isAutoGenerate = false) {
        const params = new URLSearchParams();
        if (isAutoGenerate) {
            params.append("auto_generate", isAutoGenerate.toString());
        }
        return this.base.get(`v1/executions/${executionId}?${params}`);
    }
    updateExecutionMetadata(executionId, update) {
        return this.base.patch(`v1/executions/${executionId}/workflow-plan`, removeUndefinedKeys(update));
    }
    _getExecutionWorkflowPlanRaw(executionId) {
        return this.base.makeRequestRaw("GET", `v1/executions/${executionId}/workflow-plan`, undefined, true);
    }
    getOrCreateExecutionWorkflowPlan(executionId) {
        return this._getExecutionWorkflowPlanRaw(executionId).then((response) => {
            if (response.status == 404) {
                return this.createExecutionWorkflowPlan(executionId, true);
            }
            return response.json();
        });
    }
    getExecutionWorkflowPlan(executionId, isAutoGenerate = false) {
        if (isAutoGenerate) {
            return this.getOrCreateExecutionWorkflowPlan(executionId);
        }
        return this._getExecutionWorkflowPlanRaw(executionId).then((response) => response.json());
    }
    createExecutionWorkflowPlan(executionId, isAutoGenerate = false) {
        const params = new URLSearchParams();
        if (isAutoGenerate) {
            params.append("auto_generate", isAutoGenerate.toString());
        }
        return this.base.post(`v1/executions/${executionId}/workflow-plan?${params}`);
    }
    updateExecutionWorkflowPlan(executionId, update) {
        return this.base.patch(`v1/executions/${executionId}/workflow-plan`, removeUndefinedKeys(update));
    }
    openAgentWebSocket() {
        const apiToken = getAPIToken() ?? "";
        const agentEndpoint = this.base
            .getBaseUrl()
            .replace("https://", "wss://")
            .replace("http://", "ws://")
            .replace("aible-app", "aible-agent") + "v1/agent_ws";
        const url = new URL(agentEndpoint);
        if (apiToken) {
            url.searchParams.append("token", apiToken);
        }
        return new WebSocket(url.toString());
    }
    openAgentStreamAsReader(payload) {
        return this.base.makeRequestRaw("POST", "chat/stream", payload).then((response) => response.body?.getReader());
    }
}
